/*

.toggle               Containing block. Toggles states between 'toggled-on' and 'toggled-off'
  .toggle__trigger    An element that when clicked triggers a toggle of states
  .toggle__on         Elements with this class will only be displayed in the 'toggled-on' state
  .toggle__off        Elements with this class will only be displayed in the 'toggled-off' state

  (See _toggle.scss for styling details)

*/

function toggleTriggerFired(e, $trigger) {
  if ($(e.target).hasClass('toggle__no_trigger')) {
    return;
  }
  const $toggle = $trigger.closest(".toggle,[class*='toggle--']");
  const $body = $('body');

  const onClass = 'toggled-on';
  const offClass = 'toggled-off';
  const hiddenClass = 'toggled-off--hidden';
  const panelOpen = 'help-panel-open';

  const state = $toggle.hasClass(onClass);
  if (state) {
    $toggle.addClass(offClass);
    $toggle.removeClass(onClass);

    if ($body.hasClass(panelOpen)) {
      $body.removeClass(panelOpen);
    }

    // Hide element from keyboard/screenreaders at end of transition
    $toggle.one('transitionend', () => {
      $toggle.addClass(hiddenClass);
    });
  } else {
    requestAnimationFrame(() => {
      $toggle.off('transitionend');
      $toggle.removeClass(hiddenClass);

      requestAnimationFrame(() => {
        $toggle.addClass(onClass);
        $toggle.removeClass(offClass);
      });
    });
  }

  $toggle.trigger('toggled', !state);

  const focusTarget = $trigger.data('toggle-focus-target');
  if (focusTarget) {
    document.getElementById(focusTarget).focus();
  }
}

$(() => {
  $(document).on(
    'click',
    '.toggle__trigger:not(select, input, .select2-container)',
    (e) => {
      toggleTriggerFired(e, $(e.currentTarget));
    }
  );

  $(document).on(
    'change',
    'select.toggle__trigger, input.toggle__trigger',
    (e) => {
      toggleTriggerFired(e, $(e.currentTarget));
    }
  );

  $(".toggle,[class*='toggle--']")
    .toArray()
    .forEach((toggle) => {
      const $toggle = $(toggle);
      $toggle.toggleClass('toggled-off', !$toggle.hasClass('toggled-on'));
    });
});
